document.addEventListener('DOMContentLoaded', () => {
    const showMoreButton = document.getElementById('show-more-btn') as HTMLButtonElement | null;

    if (showMoreButton) {
        showMoreButton.addEventListener('click', () => {
            const hiddenItems = document.querySelectorAll('li.author-page-articles__hidden-item') as NodeListOf<HTMLLIElement>;
            let shownCount = 0;

            for (let i = 0; i < hiddenItems.length && shownCount < 5; i++) {
                const item = hiddenItems[i];
                if (item.offsetParent === null) { // Checks if the item is hidden (works for inline and CSS)
                    item.classList.remove("hidden");
                    shownCount++;
                }
            }

            // Hide the button if no more items are left to show
            const remainingHidden = Array.from(hiddenItems).filter(item => item.offsetParent === null);
            if (remainingHidden.length === 0) {
                showMoreButton.style.display = 'none';
            }
        });
    }
});